import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_CATEGORY,
   GET_CATEGORY,
   UPDATE_CATEGORY,
   DELETE_CATEGORY,
   GET_ONE_CATEGORY,
   MULTI_DELETE_CATEGORY,
} from '../types';

// export const getCategory = () => async (dispatch) => {
//     try {
//       const res = await axios.get('/category/all');

//       if (res.data.code === 1) {
//         dispatch({ type: GET_CATEGORY, payload: res.data.data });
//       }
//     } catch (err) {
//       // console.error("Failed to get Category. Please try again. :", err);
//     }
// };

export const getCategory = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/category/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CATEGORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      } else {
         toast.error('Failed to load categories');
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.res.data.errors[0].message) {
         toast.error(err.res.data.errors[0].message);
      }
      // console.error('Error fetching categories:', err);
      // toast.error('Error fetching categories. Please try again.');
   }
};

export const addCategory = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/category/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_CATEGORY, payload: res.data.data });
         toast.success('Category added successfully!');
         return;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err.response?.data?.errors?.[0]?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // if (err.response.data.errors[0].message) {
      //   toast.error(err.response.data.errors[0].message);
      // }
      // toast.error('Failed to add Category. Please try again.', err);
   }
};

export const updateCategory =
   (formData, options = {}) =>
      async (dispatch) => {
         try {
            const isStatusUpdateOnly = options?.statusOnly === true;

            const endpoint = isStatusUpdateOnly ? '/category/update/status' : '/category/update';

            const res = await axios.post(endpoint, formData);

            if (res.data.code === 1) {
               dispatch({ type: UPDATE_CATEGORY, payload: res.data.data });

               const message = isStatusUpdateOnly ? 'Status updated successfully!' : 'Category updated successfully!';

               toast.success(message);
            } else if (res.data.code === 2) {
               toast.warn(res.data.message);
            }
         } catch (err) {
            if (err.response?.data?.errors?.[0]?.message) {
               toast.error(err.response.data.errors[0].message);
            } else {
               toast.error('Failed to update category. Please try again.');
            }
            throw err;
         }
      };

// Delete Category
export const deleteCategory = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/category/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_CATEGORY, payload: { id } });
         setTimeout(() => {
            toast.success('Category deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete category. Please try again.');
   }
};

export const getSingleCategory = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/category/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_CATEGORY, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const multiDeleteCategory = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/category/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_CATEGORY, payload: res.data.data });

         setTimeout(() => {
            toast.success('Category deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};
